import React from 'react'
import { useSelector } from 'react-redux'

export const PanelRender = React.memo(({ path, children, status = false, alwaysOn = false }) => {
  const show = useSelector((state) => state.getIn(path, status))
  return alwaysOn || show ? children : null
})
